














































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Meta } from '@sophosoft/vue-meta-decorator'
import { TableItem, TableHeaderItem } from '@/utils/types'
import { Badge, Shard } from '@/store/modules/lib'
import ShardView from './ShardList/ShardView.vue'
import ShardDetailView from './ShardList/ShardDetailView.vue'
import ShardToolbar from './ShardList/ShardToolbar.vue'
import { TranslateResult } from 'vue-i18n'
import SidebarDialog from '@/components/lfs/Dialog/SidebarDialog.vue';
import Tooltip from '@/components/UI/Tooltip.vue';

const auth = namespace('auth')
const profile = namespace('profile')
const shards = namespace('shards')
const event = namespace('event')
const sidebarDialog = namespace('dialog')
const roistat = namespace('roistat')


@Component({
  components: {
    ShardView,
    ShardDetailView,
    ShardToolbar,
    SidebarDialog,
    Tooltip
  }
})
export default class ShardList extends Vue {
  @Meta
  getMetaInfo () {
    return {
      title: `LeadFrog - ${ this.$t('shardList.title') }`
    }
  }

  protected pageLoading: boolean = true

  protected companies: any = []

  @auth.State('exhibitorId') protected _exhibitor: any
  @profile.Getter('plan') protected plan: any
  @shards.Action('loadPendingShards') protected loadPendingShards: any
  @shards.Action('saveShard') protected saveShard: any
  @event.State('eventId') protected eventId!: string

  @shards.Mutation('setMapShards') protected setMapShards:any
  @shards.Mutation('clearFilterShards') protected clearFilterShards:any
  @shards.Getter('GetShards') protected GetShards:any
  @shards.Getter('GetCountFiltersShards') protected GetCountFiltersShards:any
  @shards.Getter('GetLoadFromServer') protected GetLoadFromServer:any
  @shards.Action('actionGetShardsFromServer') protected actionGetShardsFromServer:any

  @sidebarDialog.Mutation('SetSidebarDialogShow') protected show:any
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any


  get filteredShards () {
    this.companies = this.GetShards
      .filter((shard:Shard) => shard.target_type == 'company')
      .map((shard:Shard) => {
        return { name: shard.title, id: shard._company }
      })
    let shards = this.selectedFilter
      ? this.GetShards.filter((shard:Shard) => shard._badge === this.selectedFilter)
      : this.GetShards
    shards.sort((a: Shard, b: Shard) => (a.timestamp < b.timestamp ? 1 : -1))
    let result: any = {}
    shards.map((shard:Shard) => {
      let date = this.$moment(shard.timestamp, 'X')
        .locale('ru')
        .format('DD MMM')
      if (date in result) result[date].push(shard)
      else result[date] = [shard]
    })

    return result
  }
  protected headers: TableHeaderItem[] = []
  protected isScrolled: boolean = false
  protected shards: Shard[] = []
  protected selectedShard: Shard | object = {}

  protected get tableShards(): TableItem[] {
    return this.shards.map((sh: Shard) => {
      return {
        type:
          sh.target_type == 'badge'
            ? 'Бейдж'
            : sh.target_type == 'company'
            ? 'Компания'
            : 'Продукт',
        title: sh.title,
        subtitle: sh.subtitle,
        date: this.$moment(sh.timestamp, 'X')
          .locale('ru')
          .format('DD.MM.YYYY hh:mm'),
      }
    })
  }

  protected selectedFilter: string = ''
  selectFilter (value: string) {
    this.selectedFilter = value
  }

  protected hideDeferred: boolean = false
  changeHideDeferred (value: boolean) {
    this.hideDeferred = value
  }

  protected emailDlgState: boolean = false
  protected email: string = ''
  protected msgDlgState: boolean = false
  protected msgDlgTitle: TranslateResult | string = ''
  protected msgDlgText: TranslateResult | string = ''
  protected msgDlgClose: TranslateResult | string = ''

  protected openSendDlg () {
    this.email = ''
    this.emailDlgState = true
  }
  selectShard (shard: Shard) {
    this.selectedShard = shard
  }
  protected closeSelectedShard () {
    this.selectedShard = {}
  }

  disabledBtn:boolean = true

  @Watch('email')
  getEmail(NewVal: any) {
    if(NewVal.trim !== ''){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(String(NewVal).toLowerCase())){
        this.disabledBtn = false
      }else {
        this.disabledBtn = true
      }
    }else {
      this.disabledBtn = true
    }
  }

  sendEmail:boolean = false


  protected downloadContacts () {
    if (this.email.trim() != '') {
      this.disabledBtn = true
      this.sendEmail = true
      Vue.axios({
        url: '/shardlist',
        method: 'POST',
        data: {
          email: this.email,
          _exhibitor: this._exhibitor,
        },
      })
        .then((resp: any) => {
          this.disabledBtn = false
          this.sendEmail = false
          this.emailDlgState = false
          this.msgDlgClose = this.$t('shardList.msgDialog.close')
          if (resp.data.status === 'ok') {
            this.msgDlgTitle = this.$t('shardList.msgDialog.title.success')
            this.msgDlgText = this.$t('shardList.msgDialog.text')
            this.msgDlgState = true
          } else {
            this.msgDlgTitle = this.$t('shardList.msgDialog.title.fail')
            this.msgDlgText = this.$t('shardList.msgDialog.error')
            this.msgDlgState = true
          }
          let params = [
            {
              "name": "“Собранные данные”: Действие “Выгрузить данные” - введена электроная почта - Отправка",
              "data": {
                "company": this.userCompany.title
              }
            }
          ]
          this.sendEvent(params)
        })
        .catch(() => {
          this.disabledBtn = true
          this.sendEmail = false
          this.emailDlgState = false
          this.msgDlgTitle = this.$t('shardList.msgDialog.title.fail')
          this.msgDlgText = this.$t('shardList.msgDialog.errorConnection')
          this.msgDlgState = true
        })
    }
  }

  protected async created (): Promise<void> {
    this.headers = [
      { value: 'type', text: 'Тип' },
      { value: 'title', text: 'Наименование' },
      { value: 'subtitle', text: 'Дополнительно' },
      { value: 'date', text: 'Дата создания' }
    ]

    try {
      this.actionGetShardsFromServer(this._exhibitor)
      // const shardsResponse = await Vue.axios({
      //   url: `/web/shards/${this._exhibitor}`,
      //   method: 'GET',
      // })
      //
      // if (shardsResponse.data.code == '01') {
      //   this.shards = shardsResponse.data.data
      // }

      // const pendingShards = this.shards.some((v: Shard) => v.target_type === 'pending_badge' || v.target_type === 'pending_products')

      // if (pendingShards) {
      //   let badgeIds: string = ''
      //   let productIds: string = ''
      //
      //   this.shards.forEach((v: Shard) => {
      //     if (v.target_type === 'pending_badge') {
      //       badgeIds += `\\"${ v._target }\\",`
      //     } else if (v.target_type === 'pending_product') {
      //       productIds += `\\"${ v._id }\\",`
      //     }
      //   })
      //
      //   if (badgeIds) badgeIds = badgeIds.substring(0, badgeIds.length - 1)
      //   if (productIds) productIds = productIds.substring(0, productIds.length - 1)
      //
      //   const pendingShardsResponse = await this.loadPendingShards({
      //     eventId: this.eventId,
      //     badgeIds,
      //     productIds
      //   })
      //   const { badges, products } = pendingShardsResponse
      //   const requestedBadges: any[] = []
      //   const requestedProducts: any[] = []
      //
      //   if (badges.length) {
      //     const proccessedShardsByBadges = this.shards.map((v: Shard) => {
      //       for (const badge of badges) {
      //         if (v._target === badge.barcode) {
      //           v._target = badge._id
      //           v.target_type = 'badge'
      //
      //           requestedBadges.push({
      //             _id: v._id,
      //             _target: v.target,
      //             target_type: v.target_type
      //           })
      //
      //           break
      //         }
      //       }
      //
      //       return v
      //     })
      //
      //     await this.saveShard(requestedBadges)
      //
      //     this.shards = proccessedShardsByBadges
      //   }
      //
      //   if (products.length) {
      //     const proccessedShardsByProducts = this.shards.map((v: Shard) => {
      //       for (const product of products) {
      //         if (v._target === product._id) {
      //           v.target_type = 'product'
      //
      //           requestedProducts.push({
      //             _id: v._id,
      //             target_type: v.target_type
      //           })
      //
      //           break
      //         }
      //       }
      //
      //       return v
      //     })
      //
      //     await this.saveShard(requestedProducts)
      //
      //     this.shards = proccessedShardsByProducts
      //   }
      // }
    } catch (error) {
      console.error('ShardList Page Created Error', error)
    }
    // finally {
    //   this.pageLoading = false
    // }
  }

  showFilter() {
    this.show(true)
    let params = [
      {
        "name": "“Собранные данные”: Действие “Фильтр”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }
}
